module.exports = __webpack_public_path__ + "static/img/20.9ec8d52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20.png
// module id = 7Sb6
// module chunks = 0